import { IPerfumeConfig } from './types';

export const config: IPerfumeConfig = {
  // Metrics
  isResourceTiming: false,
  isElementTiming: false,
  // Logging
  maxTime: 30000,
};
